// extracted by mini-css-extract-plugin
export var flex = "flex-module--flex--c89de";
export var flexWrapStyle = "flex-module--flexWrapStyle--377f1";